(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/infobutton-text/assets/javascripts/react/prescript.js') >= 0) return;  svs.modules.push('/components/lb-ui/infobutton-text/assets/javascripts/react/prescript.js');

'use strict';

svs = svs || {};
svs.tb_ui = svs.tb_ui || {};
svs.tb_ui.ReactInfoButtonText = svs.tb_ui.ReactInfoButtonText || {};

$(() => {
  $('.info-button-and-text').on('click', e => {
    e.preventDefault();
    svs.core.log.getLogger('lb-ui:infobutton_text.ReactInfoButtonText').debug('Class info-button-and-text clicked to preventDefault');
  });
});

 })(window);